import React, { useState } from 'react'
import TableSearchFilter from 'components/UIComponents/TableSearchFilter'
import {
  StyledTab,
  SubmitFlex,
  MenuFlex,
} from 'modules/Users/Partials/UsersFilter/Styles/style'
import Button from 'components/Button/index'
import UserRoleFilter from 'modules/Users/Partials/UsersFilter/Partials/UserRoleFilter'
import StatusFilter from 'modules/Users/Partials/UsersFilter/Partials/StatusFilter'
import CheckIconWhite from 'components/icons/CheckIconWhite'
const { TabPane } = StyledTab

const UsersFilter = ({
  searchValue,
  setSearchValue,
  userRole,
  userRoleValue,
  setUserRoleValue,
  userStatus,
  setUserStatus,
  getUserData,
  setState,
  userList,
  getUserDataFilter,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [filterData, setFilterData] = useState({})

  const submitFilter = () => {
    setIsMenuOpen(false)
    setFilterData({
      role: userRoleValue,
      status: userStatus,
    })
    getUserDataFilter()
    setState(userStatus ?? 'all')
  }

  const filterRole = userRole.filter(role => 
    userList && Array.isArray(userList.roleId) && userList.roleId.includes(role.id)
  );
  
  const onCancelFilter = open => {
    setIsMenuOpen(!isMenuOpen)
    setUserRoleValue(filterData?.role)
    setUserStatus(filterData?.status)
  }

  const menu = (
    <MenuFlex column className="filter">
      <StyledTab
        border={true}
        tabPosition={'left'}
        type="card"
        padding="10px"
        popupClassName="filter"
      >
        <TabPane tab="User Role" key="1">
          <UserRoleFilter
            userRole={filterRole}
            userRoleValue={userRoleValue}
            setUserRoleValue={setUserRoleValue}
          />
        </TabPane>
        <TabPane tab="Status" key="2">
          <StatusFilter userStatus={userStatus} setUserStatus={setUserStatus} />
        </TabPane>
      </StyledTab>

      <SubmitFlex right>
        <Button.Secondary text="Cancel" onClick={() => onCancelFilter(false)} />
        <Button.Primary
          onClick={submitFilter}
          text="Apply Filter"
          icon={<CheckIconWhite />}
        />
      </SubmitFlex>
    </MenuFlex>
  )

  return (
    <TableSearchFilter
      placeholder="Search by name"
      menu={menu}
      open={isMenuOpen}
      setOpen={setIsMenuOpen}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      currentCount={
        userList?.count < 10
          ? userList?.count
          : userList?.currentPage * 10 - 10 + userList?.list?.length
      }
      totalCount={userList?.count}
      onOpenChange={onCancelFilter}
    />
  )
}

export default UsersFilter
